'use strict';

(function () {
  'use strict';
  /**
   * This keeps track of the imgix query params that we use with certain image types
   */

  angular.module('msUtility').constant('imgixDimensions', {
    default: '',
    smallSquare: '?fit=crop&crop=center&w=200&h=200&auto=format,enhance',
    medSquare: '?fit=crop&crop=center&w=300&h=300&auto=format,enhance',
    smallBanner: '?fit=crop&crop=center&w=620&h=349&auto=format,enhance',
    banner: '?fit=crop&crop=center&w=1200&h=675&auto=format,enhance',
    largeLandscape: '?fit=clip&w=1000&h=750&auto=format,enhance'
  });
})();